<template>
<!--푸터-->
	<div class="footer">
		<p class="footer__address">08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬) <span>대표전화: 070-4489-7241</span></p>
		<span class="footer__copy">Copyright by 2025 아트너컨설팅. All Right Reserved</span>
	</div>
</template>

<script>
export default {

}
</script>

<style>

</style>